import React from 'react';

function useMediaQuery(query) {
  const getMatches = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return !!window.matchMedia(query).matches;
  };

  const [matches, setMatches] = React.useState(getMatches);

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(!!mql.matches);
    onChange();
    try {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    } catch {
      // Safari < 14
      mql.addListener(onChange);
      return () => mql.removeListener(onChange);
    }
  }, [query]);

  return matches;
}

/**
 * ResponsiveOptionNav
 *
 * Best-effort responsive switcher:
 * - narrow screens: <select>
 * - wider screens: pill buttons (wrapping)
 */
export default function ResponsiveOptionNav({
  label = 'Select',
  options = [],
  value,
  onChange,
  mobileBreakpointPx = 520,
}) {
  const isNarrow = useMediaQuery(`(max-width: ${mobileBreakpointPx}px)`);
  const normalized = Array.isArray(options)
    ? options.map((o) => (typeof o === 'string' ? ({ value: o, label: o }) : o))
    : [];

  if (isNarrow) {
    return (
      <div style={{ marginTop: 8, marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 700, color: '#333', marginBottom: 6 }}>
          {label}
        </label>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 12,
            border: '1px solid var(--mist-300)',
            fontSize: 16,
            background: '#fff',
          }}
        >
          {normalized.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 24, marginTop: 8, flexWrap: 'wrap' }}>
      {normalized.map((o) => (
        <button
          key={o.value}
          onClick={() => onChange(o.value)}
          style={{
            padding: '8px 18px',
            borderRadius: 12,
            border: 'none',
            background: value === o.value ? 'var(--sage-600)' : 'var(--mist-200)',
            color: value === o.value ? '#fff' : 'var(--dusk-700)',
            fontWeight: value === o.value ? 600 : 400,
            fontSize: 15,
            cursor: 'pointer',
            boxShadow: value === o.value ? 'var(--shadow-soft)' : 'none',
            transition: 'all 0.15s',
          }}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

